var ContactBubble = function () {
    var wrapper;
    var showBtn;
    var closeBtn;

    let buttonAnimate = function () {
        setInterval(() => {
            wrapper.find('.contactBubble__icon').addClass("animate");
            setTimeout(() => {
                wrapper.find('.contactBubble__icon').removeClass("animate");
            }, 1000);
        }, 4200);
    }

    let handlers = function (){
        showBtn.on('click', function () {
            wrapper.find('.contactBubble_window, .contactBubble_window_wp, .contactBubble_window_phone').toggleClass("show");
        });
        closeBtn.on('click', function () {
            wrapper.find('.contactBubble_window, .contactBubble_window_wp, .contactBubble_window_phone').removeClass("show");
        });
    }

    var init = function () {
        fetch('/'+i18n.locale + '/api/v1/contactbubble', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
                if (!data.status)
                    return;
                $('body').append(data.data);

                wrapper = $(document).find('.contactBubble');
                showBtn = wrapper.find('.contactBubble__icon');
                closeBtn = wrapper.find('.contactBubble_window__close');

                handlers();
                buttonAnimate();
            })
    }

    return {
        init: function () {
            init();
        }
    };
}

$(document).ready(function () {
    setTimeout(() => {
        ContactBubble().init();
    }, 1500);
});

